export * from './CompactFooter'
